
import Auth from "@/lib/common/auth";
import { Component, Vue, Watch } from "vue-property-decorator";
import vuexStore from "@/store/vuex-store";
import { CompanyConfig } from "@/lib/common/acm";

class RouterItem {
  index = "";
  pathTo = "";
  name = "";
}

@Component({})
export default class SideLayout extends Vue {
  hoverIndex = 1;
  currentCompanyId = 0;
  showVirtualAvatarMenu = false;
  currentIndex = 1; //当前菜单栏  --当前使用

  @Watch("$route", { deep: true })
  changeSideLog(n: any, o: any) {
    this.activeIt();
  }

  mounted() {
    this.activeIt();
    const companyConfig = CompanyConfig.getInstance(parseInt(Auth.companyId));
    this.currentCompanyId = parseInt(Auth.companyId);
    this.showVirtualAvatarMenu = companyConfig.showVirtualAvatarMenu == 1;
  }
  //高亮
  activeIt() {
    switch (String(this?.$route?.name)) {
      case "list-nr":
        this.currentIndex = 1;
        break;
      case "pushList-nr":
        this.currentIndex = 2;
        break;
      case "public-daka-list-nr":
        this.currentIndex = 3;
        break;
    }
  }

  //跳转
  pathTo(to: any) {
    this.$router.push(to);
  }
  handleOpen(key: any, keyPath: any) {
    console.log(key, keyPath);
  }
  handleClose(key: any, keyPath: any) {
    console.log(key, keyPath);
  }
  goToQuestionStore() {
    // if (vuexStore.isNewAi) {
    //   this.$router.push("/ai-question-store");
    // } else {
    //   this.$router.push("/question-store");
    // }
  }
}
